import { 
    Button, 
    Flex, 
    Modal, 
    ModalBody, 
    ModalCloseButton, 
    ModalContent, 
    ModalFooter, 
    ModalHeader, 
    ModalOverlay,
    Text,  
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toDoTransferData } from ".";
import { Input } from "../../components/Forms/Input";
import { StandInfo } from "../../components/Forms/StandInfo";
import { PlusCircle } from "../../styles/icons/PlusCircle";
import { formatCurrency, formatCurrencyToApi, showToast } from "../../utils";

interface CreateTransferModalProps {
    isOpen: boolean;
    onClose: () => void;
    apiFunction: any;
    selectedSeller: toDoTransferData;
}


export function CreateTransferModal({ 
    isOpen, 
    onClose, 
    apiFunction, 
    selectedSeller, 
}: CreateTransferModalProps) {
    const [isLoading, setIsLoading] = useState(false);
    const {
        register,
        handleSubmit,
        setValue,
    } = useForm();

    useEffect(() => {
        setValue("amount", formatCurrency({value: selectedSeller?.amount}));
        // eslint-disable-next-line
    }, [isOpen])
    async function onSubmit(data: any) {
        try {
            setIsLoading(true);
            const transferData = {
                accountId: selectedSeller?.sellerAccountancy?.accountId,
                value: formatCurrencyToApi(data.amount),
            }
            await apiFunction(selectedSeller?.sellerAccountancy?.id, [transferData])
            showToast({
                message: "Repasse encaminhado para Aprovação",
                type: "success",
            });
        } catch (error) {
            //@ts-ignore
            error?.response?.data?.errors.map((error) => {
                return  showToast({
                            type: "error",
                            message: `${error?.code} - ${error?.description}`
                        })
            });
        } finally {
            setIsLoading(false);
            onClose();
        }
    }
    return (
        <Modal 
                isOpen={isOpen} 
                onClose={onClose}
            >
                <ModalOverlay />
                <ModalContent  
                    as="form" 
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <ModalHeader>
                        <Flex 
                            w="100%" 
                            maxH={56} 
                            align="center"
                            gap="2"
                        >
                            <PlusCircle
                                color="#2F54EB"
                                size={15} 
                            /> 
                            <Text>Novo Repasse</Text>
                            <ModalCloseButton />
                        </Flex>
                    </ModalHeader>
                    <ModalBody p="24px" bgColor="gray.25">
                        <Flex 
                            w="100%" 
                            direction="column" 
                            gap="2"
                        >
                            <StandInfo
                                label="Cliente"
                                value={selectedSeller?.sellerAccountancy?.sellerName}
                            />
                            <StandInfo 
                                label="Saldo atual"
                                value={formatCurrency({value: selectedSeller?.amount})}
                            />
                        </Flex>
                    </ModalBody>
                    <ModalFooter p="24px">
                            <Flex
                                w="100%" 
                                direction="column" 
                                gap="2"
                                as="form"
                            >
                                <Input
                                    name="amount"
                                    register={{...register("amount")}}
                                    label="Valor do Repasse"
                                    labelColor="black"
                                    mask="currency"
                                    defaultValue="R$ 0,00"
                                />
                                <Input
                                    name="pixKey"
                                    label="Pix"
                                    labelColor="black"
                                    defaultValue={selectedSeller?.sellerAccountancy?.pixKey}
                                    infoTooltip
                                    infoTooltipLabel="Para editar a Chave PIX, vá até as Configurações de dados bancários no Perfil do seller. "
                                    isDisabled
                                    _disabled={{
                                        color: "#000",
                                        backgroundColor: "#FAFAFA",
                                        cursor: "not-allowed"
                                    }}
                                />
                            </Flex>
                    </ModalFooter>
                    <Flex 
                        w="100%" 
                        borderTop="1px solid" 
                        borderColor="gray.50"
                        p="2"
                        justifyContent="flex-end"
                        gap="2"
                    >
                        <Button  
                            variant="secondary"
                            onClick={onClose}
                        >
                            Cancelar
                        </Button>
                        <Button 
                            variant="primary"
                            type="submit"
                            isLoading={isLoading}
                        >
                            Confirmar
                        </Button>
                    </Flex>
                </ModalContent>
            </Modal>
    )
}